import React from "react";
import PageHeading from "@common/PageHeading/PageHeading";
import bigBen from "@images/big-ben.svg";
import hat from "@images/hat.svg";
import bag from "@images/bag.svg";
import relocation from "@images/relocation.svg";
import health from "@images/health.svg";
import tax from "@images/tax.svg";
import cocktail from "@images/cocktail.svg";
import firstAid from "@images/first-aid.svg";
import BenefitsCard from "./BenefitsCard/BenefitsCard";
import "./BenefitsSection.scss";

const BenefitsSection = () => {
    const listItems = [
        {
            title: "English classes with a native speaker",
            icon: bigBen,
        },
        {
            title: "Professional education and training budget",
            icon: hat,
        },
        { title: "24 working days vacation", icon: bag },
        { title: "Health insurance", icon: health },
        {
            title: "Full tax compensation",
            icon: tax,
        },
        {
            title: "WOW team-building events",
            icon: cocktail,
        },
        {
            title: "Paid sick leave",
            icon: firstAid,
        },
        {
            title: "Relocation assistance",
            icon: relocation,
        },
    ];

    return (
        <div className="benefits-section">
            <PageHeading
                heading="Employee Benefits"
                mainParagraph="We are passionate about everything we do and with Impressit you will get:"
            />
            <div className="benefits-section-items">
                {listItems.map((item, index) => (
                    <BenefitsCard
                        benefit={item.title}
                        icon={item.icon}
                        key={index}
                    />
                ))}
            </div>
        </div>
    );
};

export default BenefitsSection;
